import script from "./policy-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./policy-list.vue?vue&type=script&setup=true&lang=ts"

import "./policy-list.vue?vue&type=style&index=0&id=60ca9134&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ca9134"]])

export default __exports__